import { Play, Pause } from "lucide-react";
import { useState, useRef, useEffect } from "react";

export function AudioPlayer({ title, src }: { title?: string; src?: string }) {
  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const audioRef = useRef<HTMLAudioElement>(null);

  const toggle = () => {
    if (!audioRef.current) return;
    if (playing) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setPlaying((v) => !v);
  };

  const fmt = (s: number) => {
    const m = Math.floor(s / 60);
    const sec = Math.floor(s % 60);
    return `${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
  };

  return (
    <div className="flex items-center gap-3 rounded-md border border-border bg-surface p-3">
      {/* ✅ Élément audio HTML natif — invisible, contrôlé par les boutons */}
      {src && (
        <audio
          ref={audioRef}
          src={src}
          onTimeUpdate={() => {
            if (!audioRef.current) return;
            const { currentTime, duration } = audioRef.current;
            setProgress(duration ? (currentTime / duration) * 100 : 0);
          }}
          onLoadedMetadata={() => {
            if (audioRef.current) setDuration(audioRef.current.duration);
          }}
          onEnded={() => setPlaying(false)}
        />
      )}

      <button
        onClick={toggle}
        disabled={!src}
        className="flex h-10 w-10 items-center justify-center rounded-full bg-foreground text-background hover:opacity-90 disabled:opacity-40"
        aria-label={playing ? "Pause" : "Play"}
      >
        {playing ? <Pause className="h-4 w-4" /> : <Play className="h-4 w-4 fill-current" />}
      </button>

      <div className="min-w-0 flex-1">
        {title && (
          <div className="truncate text-sm font-medium text-foreground">{title}</div>
        )}
        {/* ✅ Barre de progression cliquable */}
        <div
          className="mt-1.5 h-1 overflow-hidden rounded-full bg-muted cursor-pointer"
          onClick={(e) => {
            if (!audioRef.current) return;
            const rect = e.currentTarget.getBoundingClientRect();
            const ratio = (e.clientX - rect.left) / rect.width;
            audioRef.current.currentTime = ratio * audioRef.current.duration;
          }}
        >
          <div
            className="h-full bg-verified transition-all duration-100"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>

      <div className="font-mono text-xs text-muted-foreground shrink-0">
        {duration > 0 ? fmt(duration) : "--:--"}
      </div>
    </div>
  );
}
// import { Play, Pause } from "lucide-react";
// import { useState } from "react";

// export function AudioPlayer({ title }: { title?: string }) {
//   const [playing, setPlaying] = useState(false);
//   return (
//     <div className="flex items-center gap-3 rounded-md border border-border bg-surface p-3">
//       <button
//         onClick={() => setPlaying((v) => !v)}
//         className="flex h-10 w-10 items-center justify-center rounded-full bg-foreground text-background hover:opacity-90"
//         aria-label={playing ? "Pause" : "Play"}
//       >
//         {playing ? <Pause className="h-4 w-4" /> : <Play className="h-4 w-4 fill-current" />}
//       </button>
//       <div className="min-w-0 flex-1">
//         {title && <div className="truncate text-sm font-medium text-foreground">{title}</div>}
//         <div className="mt-1.5 h-1 overflow-hidden rounded-full bg-muted">
//           <div className={`h-full bg-verified transition-all ${playing ? "w-1/3" : "w-0"}`} />
//         </div>
//       </div>
//       <div className="font-mono text-xs text-muted-foreground">02:14</div>
//     </div>
//   );
// }
